import { en, ge } from "vuejs-datepicker/dist/locale";

const locales = {
  en,
  ka: ge,
};

export function getDatepickerLocale(locale) {
  return locales[locale];
}

export function getTodayDate() {
  return new Date().toISOString().slice(0, 10);
}

export function getTodayHighlight() {
  return { dates: [new Date(getTodayDate())] };
}
